// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bordered":"bordered-3aIId","flex":"flex-2ExKP"};